var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRecordingIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 16255"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 6764"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#e83f4b",
  strokeLinecap: "round",
  strokeWidth: 1.369,
  "data-name": "Group 16255"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.001 12.502a6.26 6.26 0 0 0 1.555 4.272 5.062 5.062 0 0 0 7.8 0 6.26 6.26 0 0 0 1.554-4.272",
  "data-name": "Path 6043"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.89 12.858V4.877a3 3 0 0 1 .179-1.084 2.9 2.9 0 0 1 .551-.927 2.6 2.6 0 0 1 .839-.63 2.5 2.5 0 0 1 1-.236 2.54 2.54 0 0 1 1.837.866 2.94 2.94 0 0 1 .73 2.011v7.906a2.95 2.95 0 0 1-.731 2.01 2.38 2.38 0 0 1-3.672 0 2.95 2.95 0 0 1-.731-2.01",
  "data-name": "Path 6044"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.606 22h7.703",
  "data-name": "Line 681"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.457 22v-3.594",
  "data-name": "Line 682"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.913 9.878v2.875",
  "data-name": "Line 683"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.001 9.878v2.875",
  "data-name": "Line 684"
})))));
export { SvgRecordingIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/recording_icon.c93a642a27b92d430927b51ec110cf06.svg";